export type Language = 'en' | 'lo'

export const translations: Record<Language, Record<string, string>> = {
  en: {
    // Navbar
    'nav.products': 'PRODUCTS',
    'nav.beforeAfter': 'BEFORE & AFTER',
    'nav.treatmentAreas': 'TREATMENT AREAS',
    'nav.laosMarket': 'LAOS MARKET',
    'nav.brandCI': 'BRAND CI',
    'nav.aboutUs': 'ABOUT US',
    'nav.blog': 'BLOG',
    'nav.contactUs': 'CONTACT US',

    // Hero
    'hero.title1': 'Premium',
    'hero.title2': 'Dermal Fillers',
    'hero.subtitle':
      'Revitalize your skin with our Dermal Fillers: long-lasting volume, wrinkle reduction, and enhanced elasticity and hydration.',
    'hero.viewProducts': 'View Products',
    'hero.contactUs': 'Contact Us',

    // Products / Services
    'products.label': 'Our Portfolio',
    'products.title1': 'Our',
    'products.title2': 'Products',
    'products.viewAll': 'View All Products',
    'products.dermalFillers': 'Dermal Fillers',
    'products.dermalFillersDesc':
      'Cross-linked hyaluronic acid gel for facial contouring, wrinkle reduction, and lip enhancement.',
    'products.skinBoosters': 'Skin Boosters',
    'products.skinBoostersDesc':
      'Non-cross-linked HA for deep skin hydration and overall rejuvenation.',
    'products.medicalHA': 'Medical Sodium Hyaluronate',
    'products.medicalHADesc':
      'Specialized formulations for ophthalmic and orthopedic medical applications.',
    'products.regenerative': 'Regenerative Medicine',
    'products.regenerativeDesc':
      'Advanced collagen sponge and tissue engineering materials for clinical use.',
    'products.fineLines': 'Fine Lines',
    'products.deepWrinkles': 'Deep Wrinkles',
    'products.lipEnhancement': 'Lip Enhancement',
    'products.facialContouring': 'Facial Contouring',
    'products.skinHydration': 'Skin Hydration',
    'products.brightening': 'Brightening',
    'products.fineLinePrevention': 'Fine Line Prevention',
    'products.skinElasticity': 'Skin Elasticity',
    'products.eyeSurgeryAid': 'Eye Surgery Aid',
    'products.jointLubrication': 'Joint Lubrication',
    'products.woundHealing': 'Wound Healing',
    'products.adhesionPrevention': 'Adhesion Prevention',
    'products.hemostasis': 'Hemostasis',
    'products.woundCare': 'Wound Care',
    'products.tissueRepair': 'Tissue Repair',
    'products.boneRegeneration': 'Bone Regeneration',

    // Before & After
    'beforeAfter.label': 'Clinical Results',
    'beforeAfter.title1': 'Before &',
    'beforeAfter.title2': 'After',
    'beforeAfter.subtitle':
      'See the natural, long-lasting results achieved with Singderm dermal fillers. Our advanced cross-linking technology ensures smooth integration and durable volume.',
    'beforeAfter.nasolabial': 'Nasolabial Folds',
    'beforeAfter.lips': 'Lip Enhancement',
    'beforeAfter.cheeks': 'Cheek Volume',
    'beforeAfter.chin': 'Chin Contouring',
    'beforeAfter.before': 'BEFORE',
    'beforeAfter.after': 'AFTER',
    'beforeAfter.disclaimer':
      '* Results may vary. Images show actual patients treated with Singderm.',

    // Treatment Areas
    'treatment.label': 'Applications',
    'treatment.title1': 'Comprehensive',
    'treatment.title2': 'Treatment Areas',
    'treatment.subtitle':
      "Singderm's versatile range of dermal fillers is formulated with different viscosities and elasticities to address specific facial areas, providing tailored solutions for full-face rejuvenation.",
    'treatment.nasolabial': 'Nasolabial Folds',
    'treatment.nasolabialDesc':
      'Smooth out the smile lines that run from the nose to the corners of the mouth.',
    'treatment.lips': 'Lip Enhancement',
    'treatment.lipsDesc':
      'Add volume, define the lip border, and correct asymmetries for a perfect pout.',
    'treatment.cheeks': 'Cheek Augmentation',
    'treatment.cheeksDesc':
      'Restore lost mid-face volume and lift sagging skin for a youthful contour.',
    'treatment.jawline': 'Jawline & Chin',
    'treatment.jawlineDesc':
      'Define the jawline and project the chin for a balanced, sculpted side profile.',

    // About
    'about.label': 'About Us',
    'about.title1': 'About',
    'about.title2': 'Singclean',
    'about.p1':
      "Founded in 2002, Singclean Medical has been dedicated to the innovation of absorbable biomaterials, and now has more than 20 years of expertise in the industry of absorbable biomaterials and ranks among the top 3 Chinese Manufacturer and one of the world's leading innovators in this industry.",
    'about.p2':
      'Singclean has evolved from device makers to problem solvers. We provide 8 series of products (medical sodium hyaluronate gel products, chitosan products, cross-linked sodium hyaluronate gel products, microporous polysaccharide products, oxidized regenerated cellulose products, in vitro diagnostic reagent products, collagen sponge, regenerative medicine engineering basic material products) with 50 varieties which are exported to more than 120 countries around the world.',
    'about.yearsExp': 'Years Experience',
    'about.countries': 'Countries Exported',
    'about.varieties': 'Product Varieties',
    'about.series': 'Product Series',

    // Why Choose / Solutions
    'solutions.label': 'Why Choose Us',
    'solutions.title1': 'Why Choose',
    'solutions.title2': 'Singderm',
    'solutions.subtitle':
      'Committed to providing safe, effective, and innovative absorbable biomaterials for aesthetic and medical applications globally.',
    'solutions.quality': 'Premium Quality',
    'solutions.qualityDesc':
      'Cross-linked hyaluronic acid with advanced manufacturing technology for optimal safety and efficacy.',
    'solutions.certs': 'Global Certifications',
    'solutions.certsDesc':
      'CE marked, FDA registered, meeting strict international quality standards for medical devices.',
    'solutions.results': 'Long-lasting Results',
    'solutions.resultsDesc':
      'Advanced cross-linking technology ensures durable, natural-looking aesthetic results.',
    'solutions.support': 'Expert Support',
    'solutions.supportDesc':
      'Comprehensive training and dedicated after-sales support for practitioners worldwide.',

    // Exhibitions
    'exhibitions.label': 'Global Events',
    'exhibitions.title1': '2026 Exhibition',
    'exhibitions.title2': 'Preview Q2',
    'exhibitions.subtitle':
      'Meet our team and explore our latest innovations at these upcoming global medical and aesthetic exhibitions.',
    'exhibitions.no': 'NO.',
    'exhibitions.exhibition': 'Exhibition',
    'exhibitions.address': 'Address',
    'exhibitions.time': 'Time',
    'exhibitions.booth': 'Booth No.',

    // Blog
    'blog.label': 'Insights & News',
    'blog.title1': 'Latest from',
    'blog.title2': 'Our Blog',
    'blog.viewAll': 'View All Articles',
    'blog.readMore': 'Read More',

    // Contact
    'contact.label': 'Contact Us',
    'contact.title1': 'Contact',
    'contact.title2': 'Singclean Medical',
    'contact.subtitle':
      'Interested in our products or looking for a partnership? Our international sales team is ready to help.',
    'contact.headquarters': 'Headquarters',
    'contact.address': 'Address',
    'contact.phone': 'Phone',
    'contact.email': 'Email',
    'contact.hours': 'Business Hours',
    'contact.hoursValue': 'Monday - Friday: 9:00 AM - 8:00 PM (CST)',
    'contact.formTitle': 'Send us a message',
    'contact.firstName': 'First Name',
    'contact.lastName': 'Last Name',
    'contact.emailAddress': 'Email Address',
    'contact.inquiryType': 'Inquiry Type',
    'contact.productInfo': 'Product Information',
    'contact.distribution': 'Distribution',
    'contact.pricing': 'Pricing',
    'contact.other': 'Other',
    'contact.message': 'Message',
    'contact.messagePlaceholder': 'How can we help you?',
    'contact.send': 'Send Message',

    // Laos Market
    'market.label': 'Market Insights',
    'market.title1': 'Laos Beauty',
    'market.title2': 'Market Potential',
    'market.subtitle':
      'Discover the growing demand for premium aesthetic treatments among women in Laos.',
    'market.totalPop': 'Total Population',
    'market.femalePop': 'Female Population',
    'market.targetDemo': 'Target Demographic (18-55)',
    'market.beautyConscious': 'Beauty-Conscious Women',
    'market.growth': 'Annual Market Growth',
    'market.north': 'Northern Region',
    'market.central': 'Central Region (Vientiane)',
    'market.south': 'Southern Region',

    // Brand CI
    'ci.label': 'Corporate Identity',
    'ci.title1': 'Brand',
    'ci.title2': 'Identity',
    'ci.subtitle':
      'The Story of Viva Magenta: A symbol of strength, beauty, and innovation.',
    'ci.storyTitle': 'Why Viva Magenta?',
    'ci.storyP1':
      'Viva Magenta (Pantone 18-1750) is a shade rooted in nature descending from the red family and expressive of a new signal of strength. For Singderm, it represents the perfect fusion of natural ingredients and advanced medical technology.',
    'ci.storyP2':
      'In aesthetic medicine, confidence and vitality are paramount. This bold, pulsating color exudes the exact energy we want our patients to feel. It bridges East and West, serving as a universal symbol of premium quality and fearless beauty.',
    'ci.paletteTitle': 'Our Colors',
    'ci.colorMagenta': 'Viva Magenta',
    'ci.colorMagentaDesc': 'Passion, Confidence, Beauty',
    'ci.colorBlack': 'True Black',
    'ci.colorBlackDesc': 'Elegance, Sophistication, Trust',
    'ci.colorWhite': 'Pure White',
    'ci.colorWhiteDesc': 'Purity, Safety, Clinical Precision',
    'ci.logoTitle': 'The Logo',
    'ci.typographyTitle': 'Typography',
    'ci.valuesTitle': 'Core Values',
    'ci.valInnovation': 'Innovation',
    'ci.valSafety': 'Safety',
    'ci.valBeauty': 'Beauty',
    'ci.valGlobal': 'Global Reach',

    // Footer
    'footer.description':
      'Singderm is a premium dermal filler brand by Singclean Medical, dedicated to providing safe, effective, and long-lasting aesthetic solutions for practitioners worldwide.',
    'footer.quickLinks': 'Quick Links',
    'footer.contactUs': 'Contact Us',
    'footer.copyright': '© 2026 Singclean Medical. All rights reserved.',
    'footer.privacy': 'Privacy Policy',
    'footer.terms': 'Terms of Service',
  },

  lo: {
    // Navbar
    'nav.products': 'ຜະລິດຕະພັນ',
    'nav.beforeAfter': 'ກ່ອນ & ຫຼັງ',
    'nav.treatmentAreas': 'ບໍລິເວນການປິ່ນປົວ',
    'nav.laosMarket': 'ຕະຫຼາດລາວ',
    'nav.brandCI': 'ເອກະລັກແບຣນ',
    'nav.aboutUs': 'ກ່ຽວກັບພວກເຮົາ',
    'nav.blog': 'ບົດຄວາມ',
    'nav.contactUs': 'ຕິດຕໍ່ພວກເຮົາ',

    // Hero
    'hero.title1': 'ເດີມອລ ຟິລເລີ',
    'hero.title2': 'ຄຸນນະພາບສູງ',
    'hero.subtitle':
      'ຟື້ນຟູຜິວໜັງຂອງທ່ານດ້ວຍເດີມອລ ຟິລເລີ: ປະລິມານທີ່ຍືນຍາວ, ຫຼຸດຮອຍຫ່ຽວ, ແລະ ເພີ່ມຄວາມຢືດຢຸ່ນ ແລະ ຄວາມຊຸ່ມຊື່ນ.',
    'hero.viewProducts': 'ເບິ່ງຜະລິດຕະພັນ',
    'hero.contactUs': 'ຕິດຕໍ່ພວກເຮົາ',

    // Products / Services
    'products.label': 'ຜະລິດຕະພັນຂອງພວກເຮົາ',
    'products.title1': 'ຜະລິດຕະພັນ',
    'products.title2': 'ຂອງພວກເຮົາ',
    'products.viewAll': 'ເບິ່ງຜະລິດຕະພັນທັງໝົດ',
    'products.dermalFillers': 'ເດີມອລ ຟິລເລີ',
    'products.dermalFillersDesc':
      'ເຈວ ໄຮຢາລູໂຣນິກ ແອຊິດ ແບບ cross-linked ສຳລັບການປັ້ນໜ້າ, ຫຼຸດຮອຍຫ່ຽວ, ແລະ ເສີມສ້າງປາກ.',
    'products.skinBoosters': 'ສະກິນ ບູສເຕີ',
    'products.skinBoostersDesc':
      'HA ແບບ non-cross-linked ສຳລັບການໃຫ້ຄວາມຊຸ່ມຊື່ນຜິວໜັງ ແລະ ການຟື້ນຟູ.',
    'products.medicalHA': 'ໂຊດຽມ ໄຮຢາລູໂຣເນດ ທາງການແພດ',
    'products.medicalHADesc': 'ສູດສະເພາະສຳລັບການນຳໃຊ້ທາງຈັກສຸ ແລະ ກະດູກ.',
    'products.regenerative': 'ການແພດຟື້ນຟູ',
    'products.regenerativeDesc':
      'ຟອງນ້ຳຄໍລາເຈນ ແລະ ວັດສະດຸວິສະວະກຳເນື້ອເຍື່ອ ສຳລັບການນຳໃຊ້ທາງຄລີນິກ.',
    'products.fineLines': 'ຮອຍຫ່ຽວບາງໆ',
    'products.deepWrinkles': 'ຮອຍຫ່ຽວເລິກ',
    'products.lipEnhancement': 'ເສີມສ້າງປາກ',
    'products.facialContouring': 'ປັ້ນໜ້າ',
    'products.skinHydration': 'ໃຫ້ຄວາມຊຸ່ມຊື່ນຜິວ',
    'products.brightening': 'ເຮັດໃຫ້ຜິວສົດໃສ',
    'products.fineLinePrevention': 'ປ້ອງກັນຮອຍຫ່ຽວ',
    'products.skinElasticity': 'ຄວາມຢືດຢຸ່ນຂອງຜິວ',
    'products.eyeSurgeryAid': 'ຊ່ວຍການຜ່າຕັດຕາ',
    'products.jointLubrication': 'ຫຼໍ່ລື່ນຂໍ້ຕໍ່',
    'products.woundHealing': 'ປິ່ນປົວບາດແຜ',
    'products.adhesionPrevention': 'ປ້ອງກັນການຕິດກັນ',
    'products.hemostasis': 'ຢຸດເລືອດ',
    'products.woundCare': 'ດູແລບາດແຜ',
    'products.tissueRepair': 'ສ້ອມແປງເນື້ອເຍື່ອ',
    'products.boneRegeneration': 'ຟື້ນຟູກະດູກ',

    // Before & After
    'beforeAfter.label': 'ຜົນການປິ່ນປົວ',
    'beforeAfter.title1': 'ກ່ອນ &',
    'beforeAfter.title2': 'ຫຼັງ',
    'beforeAfter.subtitle':
      'ເບິ່ງຜົນລັບທຳມະຊາດ ແລະ ຍືນຍາວ ທີ່ໄດ້ຮັບຈາກ Singderm ເດີມອລ ຟິລເລີ. ເທັກໂນໂລຢີ cross-linking ຂັ້ນສູງຂອງພວກເຮົາ ຮັບປະກັນການປະສົມທີ່ລຽບ ແລະ ປະລິມານທີ່ທົນທານ.',
    'beforeAfter.nasolabial': 'ຮ່ອງແກ້ມ',
    'beforeAfter.lips': 'ເສີມສ້າງປາກ',
    'beforeAfter.cheeks': 'ເພີ່ມປະລິມານແກ້ມ',
    'beforeAfter.chin': 'ປັ້ນຄາງ',
    'beforeAfter.before': 'ກ່ອນ',
    'beforeAfter.after': 'ຫຼັງ',
    'beforeAfter.disclaimer':
      '* ຜົນລັບອາດແຕກຕ່າງກັນ. ຮູບພາບສະແດງຄົນເຈັບຈິງທີ່ໄດ້ຮັບການປິ່ນປົວດ້ວຍ Singderm.',

    // Treatment Areas
    'treatment.label': 'ການນຳໃຊ້',
    'treatment.title1': 'ບໍລິເວນ',
    'treatment.title2': 'ການປິ່ນປົວ',
    'treatment.subtitle':
      'ຜະລິດຕະພັນ Singderm ມີຫຼາຍລະດັບຄວາມໜຽວ ແລະ ຄວາມຢືດຢຸ່ນ ເພື່ອຕອບສະໜອງບໍລິເວນໃບໜ້າສະເພາະ, ໃຫ້ການແກ້ໄຂທີ່ເໝາະສົມສຳລັບການຟື້ນຟູໃບໜ້າທັງໝົດ.',
    'treatment.nasolabial': 'ຮ່ອງແກ້ມ',
    'treatment.nasolabialDesc': 'ເຮັດໃຫ້ຮ່ອງຍິ້ມທີ່ແລ່ນຈາກດັງຫາມຸມປາກລຽບຂຶ້ນ.',
    'treatment.lips': 'ເສີມສ້າງປາກ',
    'treatment.lipsDesc': 'ເພີ່ມປະລິມານ, ກຳນົດຂອບປາກ, ແລະ ແກ້ໄຂຄວາມບໍ່ສົມມາດ.',
    'treatment.cheeks': 'ເສີມແກ້ມ',
    'treatment.cheeksDesc': 'ຟື້ນຟູປະລິມານກາງໃບໜ້າ ແລະ ຍົກຜິວທີ່ຫ້ອຍ.',
    'treatment.jawline': 'ກະດູກຄາງ & ຄາງ',
    'treatment.jawlineDesc': 'ກຳນົດກະດູກຄາງ ແລະ ຍື່ນຄາງ ເພື່ອໂປຣໄຟລ໌ທີ່ສົມດຸນ.',

    // About
    'about.label': 'ກ່ຽວກັບພວກເຮົາ',
    'about.title1': 'ກ່ຽວກັບ',
    'about.title2': 'Singclean',
    'about.p1':
      'ກໍ່ຕັ້ງໃນປີ 2002, Singclean Medical ໄດ້ອຸທິດຕົນເພື່ອການປະດິດສ້າງວັດສະດຸຊີວະພາບທີ່ດູດຊຶມໄດ້, ແລະ ປັດຈຸບັນມີປະສົບການຫຼາຍກວ່າ 20 ປີ ໃນອຸດສາຫະກຳວັດສະດຸຊີວະພາບ ແລະ ຈັດອັນດັບຢູ່ໃນ 3 ອັນດັບຕົ້ນຂອງຜູ້ຜະລິດຈີນ.',
    'about.p2':
      'Singclean ໄດ້ພັດທະນາຈາກຜູ້ຜະລິດອຸປະກອນ ມາເປັນຜູ້ແກ້ໄຂບັນຫາ. ພວກເຮົາສະໜອງ 8 ຊຸດຜະລິດຕະພັນ ກັບ 50 ຊະນິດ ທີ່ສົ່ງອອກໄປຫຼາຍກວ່າ 120 ປະເທດທົ່ວໂລກ.',
    'about.yearsExp': 'ປີປະສົບການ',
    'about.countries': 'ປະເທດທີ່ສົ່ງອອກ',
    'about.varieties': 'ຊະນິດຜະລິດຕະພັນ',
    'about.series': 'ຊຸດຜະລິດຕະພັນ',

    // Why Choose / Solutions
    'solutions.label': 'ເປັນຫຍັງເລືອກພວກເຮົາ',
    'solutions.title1': 'ເປັນຫຍັງເລືອກ',
    'solutions.title2': 'Singderm',
    'solutions.subtitle':
      'ມຸ່ງໝັ້ນໃນການສະໜອງວັດສະດຸຊີວະພາບທີ່ປອດໄພ, ມີປະສິດທິພາບ, ແລະ ນະວັດຕະກຳ ສຳລັບການນຳໃຊ້ທາງຄວາມງາມ ແລະ ການແພດທົ່ວໂລກ.',
    'solutions.quality': 'ຄຸນນະພາບສູງ',
    'solutions.qualityDesc':
      'ໄຮຢາລູໂຣນິກ ແອຊິດ ແບບ cross-linked ດ້ວຍເທັກໂນໂລຢີການຜະລິດຂັ້ນສູງ.',
    'solutions.certs': 'ໃບຢັ້ງຢືນສາກົນ',
    'solutions.certsDesc':
      'ໄດ້ຮັບ CE, ຈົດທະບຽນ FDA, ຕອບສະໜອງມາດຕະຖານຄຸນນະພາບສາກົນ.',
    'solutions.results': 'ຜົນລັບຍືນຍາວ',
    'solutions.resultsDesc':
      'ເທັກໂນໂລຢີ cross-linking ຂັ້ນສູງ ຮັບປະກັນຜົນລັບທີ່ທົນທານ ແລະ ເປັນທຳມະຊາດ.',
    'solutions.support': 'ການສະໜັບສະໜູນຈາກຜູ້ຊ່ຽວຊານ',
    'solutions.supportDesc':
      'ການຝຶກອົບຮົມ ແລະ ການສະໜັບສະໜູນຫຼັງການຂາຍ ສຳລັບຜູ້ປະຕິບັດງານທົ່ວໂລກ.',

    // Exhibitions
    'exhibitions.label': 'ງານສະແດງສາກົນ',
    'exhibitions.title1': 'ງານສະແດງ 2026',
    'exhibitions.title2': 'ພາບລວມ Q2',
    'exhibitions.subtitle':
      'ພົບທີມງານຂອງພວກເຮົາ ແລະ ສຳຫຼວດນະວັດຕະກຳລ່າສຸດ ໃນງານສະແດງທາງການແພດ ແລະ ຄວາມງາມສາກົນ.',
    'exhibitions.no': 'ລຳດັບ',
    'exhibitions.exhibition': 'ງານສະແດງ',
    'exhibitions.address': 'ທີ່ຢູ່',
    'exhibitions.time': 'ເວລາ',
    'exhibitions.booth': 'ໝາຍເລກບູດ',

    // Blog
    'blog.label': 'ຂ່າວສານ & ບົດຄວາມ',
    'blog.title1': 'ລ່າສຸດຈາກ',
    'blog.title2': 'ບົດຄວາມ',
    'blog.viewAll': 'ເບິ່ງບົດຄວາມທັງໝົດ',
    'blog.readMore': 'ອ່ານເພີ່ມເຕີມ',

    // Contact
    'contact.label': 'ຕິດຕໍ່ພວກເຮົາ',
    'contact.title1': 'ຕິດຕໍ່',
    'contact.title2': 'Singclean Medical',
    'contact.subtitle':
      'ສົນໃຈຜະລິດຕະພັນຂອງພວກເຮົາ ຫຼື ຊອກຫາການເປັນຄູ່ຮ່ວມງານ? ທີມຂາຍສາກົນຂອງພວກເຮົາພ້ອມຊ່ວຍເຫຼືອທ່ານ.',
    'contact.headquarters': 'ສຳນັກງານໃຫຍ່',
    'contact.address': 'ທີ່ຢູ່',
    'contact.phone': 'ໂທລະສັບ',
    'contact.email': 'ອີເມວ',
    'contact.hours': 'ເວລາເຮັດວຽກ',
    'contact.hoursValue': 'ວັນຈັນ - ວັນສຸກ: 9:00 - 20:00 (CST)',
    'contact.formTitle': 'ສົ່ງຂໍ້ຄວາມຫາພວກເຮົາ',
    'contact.firstName': 'ຊື່',
    'contact.lastName': 'ນາມສະກຸນ',
    'contact.emailAddress': 'ທີ່ຢູ່ອີເມວ',
    'contact.inquiryType': 'ປະເພດການສອບຖາມ',
    'contact.productInfo': 'ຂໍ້ມູນຜະລິດຕະພັນ',
    'contact.distribution': 'ການເປັນຕົວແທນຈຳໜ່າຍ',
    'contact.pricing': 'ຂໍລາຄາ',
    'contact.other': 'ອື່ນໆ',
    'contact.message': 'ຂໍ້ຄວາມ',
    'contact.messagePlaceholder': 'ພວກເຮົາຊ່ວຍທ່ານໄດ້ແນວໃດ?',
    'contact.send': 'ສົ່ງຂໍ້ຄວາມ',

    // Laos Market
    'market.label': 'ຂໍ້ມູນຕະຫຼາດ',
    'market.title1': 'ສັກກະຍະພາບຕະຫຼາດ',
    'market.title2': 'ຄວາມງາມໃນລາວ',
    'market.subtitle':
      'ຄົ້ນພົບຄວາມຕ້ອງການທີ່ເພີ່ມຂຶ້ນສຳລັບການປິ່ນປົວຄວາມງາມລະດັບພຣີມຽມໃນກຸ່ມແມ່ຍິງລາວ.',
    'market.totalPop': 'ປະຊາກອນທັງໝົດ',
    'market.femalePop': 'ປະຊາກອນຍິງ',
    'market.targetDemo': 'ກຸ່ມເປົ້າໝາຍ (18-55 ປີ)',
    'market.beautyConscious': 'ແມ່ຍິງທີ່ໃສ່ໃຈຄວາມງາມ',
    'market.growth': 'ການເຕີບໂຕຂອງຕະຫຼາດຕໍ່ປີ',
    'market.north': 'ພາກເໜືອ',
    'market.central': 'ພາກກາງ (ນະຄອນຫຼວງວຽງຈັນ)',
    'market.south': 'ພາກໃຕ້',

    // Brand CI
    'ci.label': 'ເອກະລັກອົງກອນ',
    'ci.title1': 'ເອກະລັກ',
    'ci.title2': 'ແບຣນ',
    'ci.subtitle':
      'ເລື່ອງລາວຂອງສີ Viva Magenta: ສັນຍາລັກແຫ່ງຄວາມເຂັ້ມແຂງ, ຄວາມງາມ ແລະ ນະວັດຕະກຳ.',
    'ci.storyTitle': 'ເປັນຫຍັງຕ້ອງ Viva Magenta?',
    'ci.storyP1':
      'Viva Magenta (Pantone 18-1750) ແມ່ນໂທນສີທີ່ມາຈາກທຳມະຊາດໃນຕະກູນສີແດງ ທີ່ສະແດງເຖິງພະລັງແຫ່ງຄວາມເຂັ້ມແຂງໃໝ່. ສຳລັບ Singderm, ມັນສະແດງເຖິງການປະສົມປະສານທີ່ສົມບູນແບບລະຫວ່າງສ່ວນປະສົມທຳມະຊາດ ແລະ ເທັກໂນໂລຢີທາງການແພດຂັ້ນສູງ.',
    'ci.storyP2':
      'ໃນດ້ານເວຊະສາດຄວາມງາມ, ຄວາມໝັ້ນໃຈ ແລະ ຄວາມມີຊີວິດຊີວາແມ່ນສິ່ງສຳຄັນທີ່ສຸດ. ສີທີ່ໂດດເດັ່ນນີ້ສື່ເຖິງພະລັງງານທີ່ພວກເຮົາຕ້ອງການໃຫ້ຄົນເຈັບຮູ້ສຶກ. ມັນເຊື່ອມຕໍ່ຕາເວັນອອກ ແລະ ຕາເວັນຕົກ, ເປັນສັນຍາລັກສາກົນຂອງຄຸນນະພາບລະດັບພຣີມຽມ ແລະ ຄວາມງາມທີ່ກ້າຫານ.',
    'ci.paletteTitle': 'ສີຂອງພວກເຮົາ',
    'ci.colorMagenta': 'Viva Magenta',
    'ci.colorMagentaDesc': 'ຄວາມຫຼົງໄຫຼ, ຄວາມໝັ້ນໃຈ, ຄວາມງາມ',
    'ci.colorBlack': 'True Black',
    'ci.colorBlackDesc': 'ຄວາມສະຫງ່າງາມ, ຄວາມຊັບຊ້ອນ, ຄວາມໄວ້ວາງໃຈ',
    'ci.colorWhite': 'Pure White',
    'ci.colorWhiteDesc': 'ຄວາມບໍລິສຸດ, ຄວາມປອດໄພ, ຄວາມແມ່ນຍຳທາງຄລີນິກ',
    'ci.logoTitle': 'ໂລໂກ້',
    'ci.typographyTitle': 'ຕົວອັກສອນ',
    'ci.valuesTitle': 'ຄຸນຄ່າຫຼັກ',
    'ci.valInnovation': 'ນະວັດຕະກຳ',
    'ci.valSafety': 'ຄວາມປອດໄພ',
    'ci.valBeauty': 'ຄວາມງາມ',
    'ci.valGlobal': 'ການເຂົ້າເຖິງທົ່ວໂລກ',

    // Footer
    'footer.description':
      'Singderm ເປັນແບຣນເດີມອລ ຟິລເລີ ຄຸນນະພາບສູງ ໂດຍ Singclean Medical, ມຸ່ງໝັ້ນໃນການສະໜອງການແກ້ໄຂທາງຄວາມງາມທີ່ປອດໄພ, ມີປະສິດທິພາບ, ແລະ ຍືນຍາວ ສຳລັບຜູ້ປະຕິບັດງານທົ່ວໂລກ.',
    'footer.quickLinks': 'ລິ້ງດ່ວນ',
    'footer.contactUs': 'ຕິດຕໍ່ພວກເຮົາ',
    'footer.copyright': '© 2026 Singclean Medical. ສະຫງວນລິຂະສິດ.',
    'footer.privacy': 'ນະໂຍບາຍຄວາມເປັນສ່ວນຕົວ',
    'footer.terms': 'ເງື່ອນໄຂການບໍລິການ',
  },
}
